  const CreatorCollectionList = 
     [   {
           id: 1,
           title: "coffee Theme",
           link: "creator-collection-img5.png",
           ctext: "coffee Theme",
           cresources: "80 resources",
        },
        {
            id: 2,
            title: "Christmas Gifts",
            link: "creator-collection-img4.png",
            ctext: "Christmas Gifts",
            cresources: "70 resources",
         },
         {
            id: 3,
            title: "category theme",
            link: "creator-collection-img2.png",
            ctext: "category theme",
             cresources: "30 resources",
         },
         {
             id: 4,
             alt: "freepik images",
             link: "creator-collection-img3.png",
             ctext: "freepik images",
              cresources: "25 resources",
          },
       
]
export {CreatorCollectionList};